<template>
  <div class="md-layout md-size-100 md-gutter margin-bottom-10">
    <div v-if="label" class="margin-bottom-10 md-layout-item md-size-100">
      <span>{{ label }}</span>
    </div>

    <div class="md-layout-item md-size-100 display-inline-block">
      <input type="range"
             :min="min"
             :max="max"
             :step="step"
             v-model.number="sliderValue"
             id="myRange"
             class="slider"
             :class="getClassName(className)" />

      <span v-if="displaySliderValue" class="padding-left-20">{{ displaySliderValue }}</span>
    </div>
  </div>
</template>

<script>
  import debounce from "lodash.debounce";

  export default {
    name: "Slider",
    props: {
      label: {
        type: String,
        default: null,
      },
      className: { //value: primary, accent, blue, green
        type: String,
        default: 'primary'
      },
      labelfilter: { //function to filter slider results that are displayed
        type: Function,
        default: null,
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      step: {
        type: Number,
        default: 1
      },
      defaultValue: {
        type: Number,
        default: 0
      }
    },
    data: function () {
      return {
        sliderValue: 0,
      };
    },
    computed: {
      displaySliderValue: function () {
        if (this.labelfilter != null)
          return this.labelfilter(this.sliderValue);
        else
          return this.sliderValue;
      }
    },
    created() {
      if (this.defaultValue)
        this.sliderValue = this.defaultValue;

      this.debouncedFunc = debounce(() => this.$emit('onChange', this.sliderValue), 2000);

      this.$watch('sliderValue', this.debouncedFunc);
    },
    beforeUnmount() {
      this.debounceFunc.cancel();
    },
    methods: {
      getClassName(value) {
        switch (value) {
          default:
          case 'primary':
          case 'blue':
            return 'slider-blue'

          case 'accent':
          case 'green':
            return 'slider-green'
        }
      },
    }
  };

</script>

<style>
  .slider {
    -webkit-appearance: none;
    width: 65%;
    height: 15px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
  }

    .slider:hover {
      opacity: 1;
    }

    .slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: #04AA6D;
      cursor: pointer;
    }

    .slider::-moz-range-thumb {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: #04AA6D;
      cursor: pointer;
    }

  .slider-blue::-webkit-slider-thumb {
    background: var(--blue);
  }
  
  .slider-blue::-moz-range-thumb {
    background: var(--blue);
  }
  
  .slider-green::-webkit-slider-thumb {
    background: var(--green);
  }
  
  .slider-green::-moz-range-thumb {
    background: var(--green);
  }
</style>
